import { render, staticRenderFns } from "./impactosporcredito.vue?vue&type=template&id=b1d345e4"
import script from "./impactosporcredito.vue?vue&type=script&lang=js"
export * from "./impactosporcredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports